import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../../../../../enums/queryKeys'

export const useInvalidateAdditionalFields = () => {
  const queryClient = useQueryClient()

  const invalidateAdditionalFields = useCallback(() => {
    queryClient.invalidateQueries(QueryKeys.AdditionalFields)
  }, [queryClient])

  return {
    invalidateAdditionalFields,
  }
}
